import React from 'react'
import './assets/index.css'
import { adaptV4Theme, createTheme } from '@mui/material/styles'
import { loadPersistedDataAction } from './redux/persistence-middleware'
import { Application } from './components/application/Application'
import { BrowserRouter } from 'react-router-dom'
import createI18nInstance from './i18n'
import { retrieveLanguage } from './utils/languageStore'
import { createRoot } from 'react-dom/client'
import getStore from './redux/store'
import { FetchingUserInformationAction } from './redux/auth/auth-actions'

const store = getStore()

store.dispatch(loadPersistedDataAction())

if (store.getState().auth.isAuthenticated) {
  store.dispatch(FetchingUserInformationAction())
}

const theme = createTheme(adaptV4Theme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: 12
  },
  palette: {
    primary: {
      main: '#00bcd4',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#c0392b',
      contrastText: '#ffffff'
    }
  }
}))

const i18n = createI18nInstance(retrieveLanguage())
const container = document.getElementById('root')
if (container == null) {
  throw Error('Expecting element with id=root')
}

const root = createRoot(container)
root.render(
    <BrowserRouter>
        <Application store={store} theme={theme} i18n={i18n}/>
    </BrowserRouter>
)
